import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getDeviationResourceType, getTranslatedDeviationTitle } from '../../../DeviationViews/_helpers';
import { DeviationDuperbrowseContext, DeviationLink } from '../../../Duperbrowse';
import DeviationDumbViewWithIcon from '../../../DeviationViews/DumboWithIcon';
import SidebarGrid from '../SidebarGrid';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const DeviationSidebarGrid = ({ streamId , deviations , parentDeviation , maxRows , className  })=>{
    const { t  } = useTranslation();
    const isNoDuperPreload = useFlag('fylt_duper_no_preload');
    const isFyltDuperDisabled = useFlag('fylt_duper_disabled');
    const preloadEnabled = isNoDuperPreload || isFyltDuperDisabled ? false : true;
    const renderDeviation = useCallback(({ item , width , height , className: itemClassName  })=>/*#__PURE__*/ React.createElement(DeviationLink, {
            deviation: item,
            key: item.deviationId,
            className: itemClassName,
            title: getTranslatedDeviationTitle(item, t)
        }, /*#__PURE__*/ React.createElement(DeviationDumbViewWithIcon, {
            deviation: item,
            width: width,
            height: height,
            greenLikeCrop: true
        })), [
        t
    ]);
    return /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: streamId,
        deviations: deviations,
        parent: {
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId
        },
        preloadEnabled: preloadEnabled
    }, /*#__PURE__*/ React.createElement(SidebarGrid, {
        items: deviations,
        maxRows: maxRows,
        className: className,
        renderItem: renderDeviation
    }));
};
DeviationSidebarGrid.displayName = 'DeviationSidebarGrid';
export default DeviationSidebarGrid;
